import { Alert, Box, Button, Card, CardContent, Stack, TextField, Typography } from '@mui/material'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ApiError } from '@/api/client'
import { portalApi } from './portalApi'

/** Where a customer chooses their own password, replacing the one they were given. */
export function CustomerPasswordPage() {
  const navigate = useNavigate()
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [again, setAgain] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const mismatch = again.length > 0 && next !== again
  const valid = current && next.length >= 8 && next === again

  const submit = async () => {
    setBusy(true)
    setError(null)
    try {
      await portalApi.post('/auth/password', { currentPassword: current, newPassword: next })
      navigate('/my', { replace: true })
    } catch (problem) {
      setError(problem instanceof ApiError ? problem.message : 'Could not change it just now.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Card sx={{ width: 420, maxWidth: '100%' }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h6" gutterBottom>
            Choose a password
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            The caterer set the one you have. Pick your own so only you know it.
          </Typography>
          {error ? <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert> : null}
          <Stack component="form" spacing={2} onSubmit={(e) => { e.preventDefault(); if (valid) void submit() }}>
            <TextField label="Password you were given" type="password" value={current}
              onChange={(e) => setCurrent(e.target.value)} required
              inputProps={{ 'aria-label': 'Current password' }} />
            <TextField label="New password" type="password" value={next}
              onChange={(e) => setNext(e.target.value)} required
              helperText="At least 8 characters"
              inputProps={{ 'aria-label': 'New password' }} />
            <TextField label="New password again" type="password" value={again}
              onChange={(e) => setAgain(e.target.value)} required
              error={mismatch} helperText={mismatch ? 'These do not match' : ' '}
              inputProps={{ 'aria-label': 'New password again' }} />
            <Button type="submit" variant="contained" disabled={busy || !valid}>
              {busy ? 'Saving…' : 'Save'}
            </Button>
            <Button size="small" onClick={() => navigate('/my')}>Later</Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  )
}
